import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import {
  ElderProgressBarComponent,
  ElderQuantityPipe,
  IsoDurationStr,
  Quantity,
  SubBar,
} from '@elderbyte/ngx-starter'
import { ProgressBarUtils } from '../ProgressBarUtils'
import { Duration } from '@js-joda/core'
import { WorkCenterUtilisation } from '../../work-center-utilisation'
import { ProgressBarColors } from '../ProgressBarColors'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'

@Component({
  selector: 'app-utilisation-capacity-bar',
  templateUrl: './utilisation-capacity-bar.component.html',
  styleUrls: ['./utilisation-capacity-bar.component.scss'],
  imports: [ElderProgressBarComponent, ElderTranslatePipe, ElderQuantityPipe],
})
export class UtilisationCapacityBarComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  @Input()
  public workCenterUtilisation: WorkCenterUtilisation

  @Input()
  public barThickness = 4

  @Input()
  public showLegend = false

  public readonly Colors = ProgressBarColors

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  calculateUtilisation(wcUtil: WorkCenterUtilisation): SubBar[] {
    const agg = wcUtil.stateAggregate

    const completed = this.parseDurationOrZero(agg.completed.capacityDuration)
    const progress = this.parseDurationOrZero(agg.progress.capacityDuration)
    const readyForProduction = this.parseDurationOrZero(agg.readyForProduction.capacityDuration)
    const onHold = this.parseDurationOrZero(agg.onHold.capacityDuration)
    const capacity = this.parseDurationOrZero(wcUtil.capacity)

    return ProgressBarUtils.calculateBars(
      completed.seconds(),
      progress.seconds(),
      readyForProduction.seconds(),
      onHold.seconds(),
      capacity.seconds()
    )
  }

  getCompletedWeight(workCenterUtilisation: WorkCenterUtilisation) {
    return workCenterUtilisation.stateAggregate.completed.totalWeight
  }

  getInProgressWeight(workCenterUtilisation: WorkCenterUtilisation): Quantity {
    return workCenterUtilisation.stateAggregate.progress.totalWeight
  }

  getReadyWeight(workCenterUtilisation: WorkCenterUtilisation): Quantity {
    return workCenterUtilisation.stateAggregate.readyForProduction.totalWeight
  }

  getOnHoldWeight(workCenterUtilisation: WorkCenterUtilisation) {
    return workCenterUtilisation.stateAggregate.onHold.totalWeight
  }

  /***************************************************************************
   *                                                                         *
   * Private methods                                                         *
   *                                                                         *
   **************************************************************************/

  private parseDurationOrZero(str: IsoDurationStr): Duration {
    try {
      return Duration.parse(str)
    } catch (err) {
      this.log.error('Failed to parse ISO Duration Str', err)
      return Duration.ZERO
    }
  }
}
